'use client';

import { FunctionComponent, ReactNode } from 'react';

export interface PaymentDetailsSectionProps
{
    title: string;
    children: ReactNode;
}

/**
 * Component: Common section wrapper for payment details.
 */
const PaymentDetailsSection: FunctionComponent<PaymentDetailsSectionProps> = (props) =>
{
    /** Render */
    return (
        <div className="bg-light rounded p-4 mb-4">
            <h4 className="h5 mb-3 border-bottom pb-2">{props.title}</h4>
            {props.children}
        </div>
    );
}

export default PaymentDetailsSection;